// strategic demand dropdown
export const FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_REQUEST = "FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_REQUEST";
export const FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_SUCCESS = "FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_SUCCESS";
export const FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_FAILURE = "FETCH_BLOCK_DEMAND_PLANNING_REPORTS_DD_FAILURE";

// strategic capacity table
export const FETCH_ALL_REPORTS_PAGINATION_REQUEST = "FETCH_ALL_REPORTS_PAGINATION_REQUEST";
export const FETCH_ALL_REPORTS_PAGINATION_SUCCESS = "FETCH_ALL_REPORTS_PAGINATION_SUCCESS";
export const FETCH_ALL_REPORTS_PAGINATION_FAILURE = "FETCH_ALL_REPORTS_PAGINATION_FAILURE";

export const DELETE_STRATEGIC_CAPACITY_REPORT_REQUEST = "DELETE_STRATEGIC_CAPACITY_REPORT_REQUEST";
export const DELETE_STRATEGIC_CAPACITY_REPORT_SUCCESS = "DELETE_STRATEGIC_CAPACITY_REPORT_SUCCESS";
export const DELETE_STRATEGIC_CAPACITY_REPORT_FAILURE = "DELETE_STRATEGIC_CAPACITY_REPORT_FAILURE";

// strategiccapacityactionType.js
export const EXPORT_CAPACITY_REPORT_REQUEST = "EXPORT_CAPACITY_REPORT_REQUEST";
export const EXPORT_CAPACITY_REPORT_SUCCESS = "EXPORT_CAPACITY_REPORT_SUCCESS";
export const EXPORT_CAPACITY_REPORT_FAILURE = "EXPORT_CAPACITY_REPORT_FAILURE";

// strategiccapacityactionType.js
export const FETCH_BLOCK_CAPACITY_TABLE_REQUEST = "FETCH_BLOCK_CAPACITY_TABLE_REQUEST";
export const FETCH_BLOCK_CAPACITY_TABLE_SUCCESS = "FETCH_BLOCK_CAPACITY_TABLE_SUCCESS";
export const FETCH_BLOCK_CAPACITY_TABLE_FAILURE = "FETCH_BLOCK_CAPACITY_TABLE_FAILURE";
// strategiccapacityactionType.js
export const FETCH_CAPACITY_TABLE_REPORT_REQUEST = "FETCH_CAPACITY_TABLE_REPORT_REQUEST";
export const FETCH_CAPACITY_TABLE_REPORT_SUCCESS = "FETCH_CAPACITY_TABLE_REPORT_SUCCESS";
export const FETCH_CAPACITY_TABLE_REPORT_FAILURE = "FETCH_CAPACITY_TABLE_REPORT_FAILURE";

// strategiccapacityactionType.js
export const FETCH_REPORT_NOTE_REQUEST = "FETCH_REPORT_NOTE_REQUEST";
export const FETCH_REPORT_NOTE_SUCCESS = "FETCH_REPORT_NOTE_SUCCESS";
export const FETCH_REPORT_NOTE_FAILURE = "FETCH_REPORT_NOTE_FAILURE";

export const UPDATE_REPORT_NOTE_REQUEST = "UPDATE_REPORT_NOTE_REQUEST";
export const UPDATE_REPORT_NOTE_SUCCESS = "UPDATE_REPORT_NOTE_SUCCESS";
export const UPDATE_REPORT_NOTE_FAILURE = "UPDATE_REPORT_NOTE_FAILURE";

// strategiccapacityactionType.js
export const FETCH_CAPACITY_DAILY_VIEW_REQUEST = "FETCH_CAPACITY_DAILY_VIEW_REQUEST";
export const FETCH_CAPACITY_DAILY_VIEW_SUCCESS = "FETCH_CAPACITY_DAILY_VIEW_SUCCESS";
export const FETCH_CAPACITY_DAILY_VIEW_FAILURE = "FETCH_CAPACITY_DAILY_VIEW_FAILURE";

// actionType
export const FETCH_CAPACITY_QUARTERLY_VIEW_REQUEST = "FETCH_CAPACITY_QUARTERLY_VIEW_REQUEST";
export const FETCH_CAPACITY_QUARTERLY_VIEW_SUCCESS = "FETCH_CAPACITY_QUARTERLY_VIEW_SUCCESS";
export const FETCH_CAPACITY_QUARTERLY_VIEW_FAILURE = "FETCH_CAPACITY_QUARTERLY_VIEW_FAILURE";


// strategiccapacityactionType.js
export const FETCH_CAPACITY_FILTER_DD_REQUEST = "FETCH_CAPACITY_FILTER_DD_REQUEST";
export const FETCH_CAPACITY_FILTER_DD_SUCCESS = "FETCH_CAPACITY_FILTER_DD_SUCCESS";
export const FETCH_CAPACITY_FILTER_DD_FAILURE = "FETCH_CAPACITY_FILTER_DD_FAILURE";

export const FETCH_WORKLIST_BY_RPCE_REQUEST = "FETCH_WORKLIST_BY_RPCE_REQUEST";
export const FETCH_WORKLIST_BY_RPCE_SUCCESS = "FETCH_WORKLIST_BY_RPCE_SUCCESS";
export const FETCH_WORKLIST_BY_RPCE_FAILURE = "FETCH_WORKLIST_BY_RPCE_FAILURE";

export const FETCH_ONBOARDING_SITE_LEGEND_REQUEST = 'FETCH_ONBOARDING_SITE_LEGEND_REQUEST';
export const FETCH_ONBOARDING_SITE_LEGEND_SUCCESS = 'FETCH_ONBOARDING_SITE_LEGEND_SUCCESS';
export const FETCH_ONBOARDING_SITE_LEGEND_FAILURE = 'FETCH_ONBOARDING_SITE_LEGEND_FAILURE';

// strategiccapacityactionType.js
export const DRAFT_CAPACITY_TABLE_REQUEST = "DRAFT_CAPACITY_TABLE_REQUEST";
export const DRAFT_CAPACITY_TABLE_SUCCESS = "DRAFT_CAPACITY_TABLE_SUCCESS";
export const DRAFT_CAPACITY_TABLE_FAILURE = "DRAFT_CAPACITY_TABLE_FAILURE";

export const PUBLISH_CAPACITY_TABLE_REQUEST = "PUBLISH_CAPACITY_TABLE_REQUEST";
export const PUBLISH_CAPACITY_TABLE_SUCCESS = "PUBLISH_CAPACITY_TABLE_SUCCESS";
export const PUBLISH_CAPACITY_TABLE_FAILURE = "PUBLISH_CAPACITY_TABLE_FAILURE";

// strategiccapacity cascading WeekQuarterByMonthYear
export const FETCH_WEEK_QUARTER_BY_MONTH_YEAR_REQUEST = "FETCH_WEEK_QUARTER_BY_MONTH_YEAR_REQUEST";
export const FETCH_WEEK_QUARTER_BY_MONTH_YEAR_SUCCESS = "FETCH_WEEK_QUARTER_BY_MONTH_YEAR_SUCCESS";
export const FETCH_WEEK_QUARTER_BY_MONTH_YEAR_FAILURE = "FETCH_WEEK_QUARTER_BY_MONTH_YEAR_FAILURE";



export const RESET_STRATEGIC_CAPACITY_STATE = "RESET_STRATEGIC_CAPACITY_STATE";
